package com.clany.backoffice.data.network.response

import kotlinx.serialization.Serializable

@Serializable
enum class PushPlatform {
    ANDROID,
    IOS,
    ALL
}

@Serializable
enum class NotificationType {
    REENGAGEMENT,   // Recuperar usuarios inactivos
    PROMOTIONAL,    // Ofertas, descuentos en suscripciones
    ANNOUNCEMENT,   // Novedades y nuevas funciones
    REMINDER,       // Recordatorios (TyC, invitaciones, eventos pendientes)
    MAINTENANCE     // Avisos de mantenimiento del sistema
}

@Serializable
data class AdvancedNotificationFilter(
    // Specific users
    val includeUserIds: List<String>? = null,
    val excludeUserIds: List<String>? = null,
    // User profile
    val userTypes: List<String>? = null,
    val userStatuses: List<String>? = null,
    val locales: List<String>? = null,
    val authProviders: List<String>? = null,
    val appVersions: List<String>? = null,
    val isAnonymized: Boolean? = null,
    val shouldUpdateTyc: Boolean? = null,
    val hasLinkedMember: Boolean? = null,
    val createdAfter: Long? = null,
    val createdBefore: Long? = null,
    val lastActiveAfter: Long? = null,
    val lastActiveBefore: Long? = null,
    // Push / Device
    val platforms: List<String>? = null,
    val hasDeviceTokens: Boolean? = null,
    // Clans / Accounts
    val hasAccounts: Boolean? = null,
    val minAccountCount: Int? = null,
    val maxAccountCount: Int? = null,
    val accountRoles: List<String>? = null,
    val accountUserStatuses: List<String>? = null,
    // Subscriptions (via subscriptionWebhookEvents collection)
    val hasActiveSubscription: Boolean? = null,
    val subscriptionPlans: List<String>? = null,    // matches productId field
    val subscriptionStatuses: List<String>? = null, // matches type field: INITIAL_PURCHASE, RENEWAL, EXPIRATION, CANCELLATION
    // Members (members created by the user, via members.createdBy)
    val isMember: Boolean? = null,
    val minMemberCount: Int? = null,
    val maxMemberCount: Int? = null,
    // Events (events created by the user, via events.userId)
    val hasEvents: Boolean? = null,
    val minEventCount: Int? = null,
    val maxEventCount: Int? = null,
    val eventTypes: List<String>? = null,
    // Invitations
    val hasSentInvitations: Boolean? = null,
    val hasReceivedInvitations: Boolean? = null,
    val invitationStatuses: List<String>? = null,
    val minSentInvitations: Int? = null,
    val maxSentInvitations: Int? = null,
    val minReceivedInvitations: Int? = null,
    val maxReceivedInvitations: Int? = null,
)

@Serializable
data class SendPushRequest(
    val title: String,
    val body: String,
    val data: Map<String, String>? = null,
    val filter: AdvancedNotificationFilter,
    val environment: String,
    val notificationType: NotificationType = NotificationType.REENGAGEMENT
)

@Serializable
data class SendPushResponse(
    val successCount: Int,
    val failureCount: Int,
    val errors: List<String>
)

@Serializable
data class SendEmailRequest(
    val subject: String,
    val bodyHtml: String,
    val filter: AdvancedNotificationFilter,
    val notificationType: NotificationType = NotificationType.REENGAGEMENT
)

@Serializable
enum class NotificationChannelType {
    PUSH, EMAIL
}

@Serializable
data class PreviewTargetRequest(
    val filter: AdvancedNotificationFilter,
    val channel: NotificationChannelType
)

@Serializable
data class PreviewTargetResponse(
    val count: Int,
    val sampleUsers: List<String>
)

@Serializable
data class FilterUsersRequest(
    val filter: AdvancedNotificationFilter,
    val page: Int = 1,
    val limit: Int = 20
)
